import { combineReducers } from 'redux'

import {
  createReducer,
  updateObject,
  updateItemInArray,
  createNamedReducer,
} from 'helpers/ReducerUtil'
import {
  TOGGLE_POPUP,
  TOGGLE_FILTER,
  INITIALIZE_FILTER,
  UPDATE_CONFIG_SELECTION,
  UPDATE_CONFIG_SOURCE,
  ADD_CONFIG,
  DELETE_PART,
  UPDATE_CURRENT_CONFIG,
  REFRESH_FILTER,
  ARCH,
  BRAND,
  CLASSIFICATION,
  UPDATE_CONFIG_MODEL_NAME,
} from './constants'

const togglePopup = (value) => !value

const toggleFilter = (values, action) => {
  const { index } = action
  return updateObject(values, {[index]: !(values[index])})
}

const refreshFilter = (values, action) => {
  let refreshedFilters = { ...values }

  for (let filterName in refreshedFilters) {
    if (refreshedFilters.hasOwnProperty(filterName)) {
      refreshedFilters[filterName] = false
    }
  }

  return refreshedFilters
}

const updateConfigSelection = (values, action) => {
  return action.newConfig
}

const updateConfigSource = (values, action) => {
  return action.newConfig
}

const addConfig = (value, action) => {
  const configs = action.configs.map((config) => {
    return {...config, modelName: ''}
  })
  return [...value, ...configs]
}

const updateConfigModelName = (values, {index, modelName}) => {
  var configs = values.slice()
  configs[index].modelName = modelName
  return configs
}

const deletePart = (value, action) => {
  const { index } = action
  let newParts = [...value]
  newParts = newParts.filter((row, rowIndex) => {
    if (row.hasOwnProperty('id')) return row.id != index
    else return index != rowIndex
  })
  return newParts
}

const updateCurConfig = (value, action) => {
  return action.curConfig
}

const togglePopupReducer = createReducer(false, {
  [TOGGLE_POPUP]: togglePopup
})

const updateConfigSelectionReducer = createReducer([], {
  [UPDATE_CONFIG_SELECTION]: updateConfigSelection
})

const updateConfigSourceReducer = createReducer([], {
  [UPDATE_CONFIG_SOURCE]: updateConfigSource
})

const updateCurConfigReducer = createReducer({}, {
  [UPDATE_CURRENT_CONFIG]: updateCurConfig
})

const initFilters = (state, action) => {
  const { filters } = action
  let newFilters = {...filters}
  for (const filterKey in filters) {
    if (!filters.hasOwnProperty(filterKey)) continue

    newFilters[filterKey] = false
  }

  return newFilters
}

const filterReducer = createReducer({}, {
  [INITIALIZE_FILTER]: initFilters,
  [TOGGLE_FILTER]: toggleFilter,
  [REFRESH_FILTER]: refreshFilter,
})

export const notebookValueReducer = createReducer([], {
  [ADD_CONFIG]: addConfig,
  [UPDATE_CONFIG_MODEL_NAME]: updateConfigModelName,
  [DELETE_PART]: deletePart,
})

export const createUiReducer = (uiPath) => {
  const namedUiReducer = (type) => {
    return createNamedReducer(type + uiPath, filterReducer)
  }

  return combineReducers({
    togglePopup: togglePopupReducer,
    configSelection: updateConfigSelectionReducer,
    configSource: updateConfigSourceReducer,
    curConfig: updateCurConfigReducer,
    archFilter: namedUiReducer(ARCH),
    brandFilter: namedUiReducer(BRAND),
    classFilter: namedUiReducer(CLASSIFICATION),
  })
}

